import axios from "axios";

export default async function getRecentActivity() {
    const res = await axios.get("/recent-activities");
    return res.data;
}